const password = {
    unsupported_encryption_method: 'El método de encriptación {{name}} no es compatible.',
    pepper_not_found: 'No se encontró el password pepper. Por favor revisa tus variables de entorno.',
};
export default password;
